import { ApiLandingPageVideo, ApiVideo } from '@storefronts/common-types'

export const getAnimatedUrl = (
    video: Pick<ApiLandingPageVideo | ApiVideo, 'animatedUrl' | 'aspectRatio'>,
    highQuality = false,
): string | null => {
    const { animatedUrl } = video
    if (!animatedUrl) return null

    let url = animatedUrl

    // Check if the video is square (1:1 aspect ratio)
    const isSquare = video.aspectRatio === '1:1'

    if (highQuality) {
        if (isSquare) {
            url = url
                .replace('w_180,h_320', 'w_400,h_400')
                .replace('w_225,h_400', 'w_400,h_400')
        } else {
            url = url
                .replace('w_180,h_320', 'w_562,h_1000')
                .replace('w_225,h_400', 'w_337,h_600')
        }
    } else {
        if (isSquare) {
            url = url.replace('w_180,h_320', 'w_125,h_125')
        } else {
            url = url.replace('w_180,h_320', 'w_225,h_400')
        }
    }
    return url.replace('.gif', '.mp4').replace('.webm', '.mp4')
}
